import React, { useEffect } from "react";

const WelcomeMessage = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes fadeInUp {
        0% { opacity: 0; transform: translateY(20px); }
        100% { opacity: 1; transform: translateY(0); }
      }

      .welcome-section {
        display: flex;
        justify-content: center;
        padding: 44px 20px;
        box-sizing: border-box;
      }

      .welcome-tile {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        gap: 36px;
        padding: 36px;
        background: linear-gradient(160deg, #0d7a93 0%, #025261 100%);
        border-radius: 16px;
        box-shadow: 0 16px 40px rgba(2, 82, 97, 0.25);
        animation: fadeInUp 0.8s ease-out;
        max-width: 1200px;
        width: 100%;
      }

      .welcome-left {
        flex: 2 1 380px;
        text-align: left;
      }

      .welcome-eyebrow {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 1.8px;
        text-transform: uppercase;
        color: #e8b923;
        margin: 0 0 10px 0;
      }

      .welcome-heading {
        font-size: 20px;
        font-weight: 800;
        font-family: 'Montserrat', sans-serif;
        color: #ffffff;
        letter-spacing: -0.2px;
        margin: 0 0 6px 0;
        line-height: 1.3;
      }

      .welcome-subheading {
        margin-top: 4px;
        font-size: 15px;
        font-weight: 600;
        color: #dfeff5;
      }

      .welcome-message {
        font-size: 13px;
        line-height: 1.7;
        color: #dfeff5;
        margin-top: 14px;
        text-align: left;
        font-weight: 400;
      }

      .welcome-right {
        flex: 1 1 260px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .welcome-image-wrapper {
        width: 220px;
        height: 220px;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
        box-sizing: border-box;
      }

      .welcome-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
        display: block;
      }

      .welcome-name {
        background: #e8b923;
        padding: 7px 16px;
        border-radius: 6px;
        margin-top: 14px;
        font-weight: 700;
        font-size: 13px;
        color: #0f172a;
        letter-spacing: 0.1px;
      }

      .welcome-designation {
        font-size: 12px;
        color: #dfeff5;
        margin-top: 6px;
        font-weight: 600;
        letter-spacing: 0.2px;
      }

      /* ===== Responsive ===== */
      @media (max-width: 900px) {
        .welcome-image-wrapper {
          width: 190px;
          height: 190px;
        }
        .welcome-heading {
          font-size: 18px;
        }
      }

      @media (max-width: 768px) {
        .welcome-section {
          padding: 32px 16px;
        }
        .welcome-tile {
          flex-direction: column;
          padding: 26px 22px;
          gap: 24px;
          text-align: center;
        }
        .welcome-left {
          text-align: center;
        }
        .welcome-message {
          text-align: center;
        }
        .welcome-heading {
          font-size: 18px;
        }
        .welcome-subheading {
          font-size: 14px;
        }
        .welcome-image-wrapper {
          width: 170px;
          height: 170px;
        }
      }

      @media (max-width: 480px) {
        .welcome-tile {
          padding: 20px 16px;
          border-radius: 12px;
        }
        .welcome-heading {
          font-size: 16px;
        }
        .welcome-subheading {
          font-size: 13px;
        }
        .welcome-message {
          font-size: 12px;
          margin-top: 10px;
        }
        .welcome-image-wrapper {
          width: 140px;
          height: 140px;
          border-radius: 12px;
        }
        .welcome-name {
          font-size: 11.5px;
          padding: 6px 12px;
        }
        .welcome-designation {
          font-size: 10.5px;
        }
      }

      @media (max-width: 360px) {
        .welcome-image-wrapper {
          width: 120px;
          height: 120px;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <section className="welcome-section">
      <div className="welcome-tile">
        {/* Left: Welcome Message */}
        <div className="welcome-left">
          <p className="welcome-eyebrow">A Message From Leadership</p>
          <h2 className="welcome-heading">Welcome Message from CEO</h2>
          <div className="welcome-subheading">Welcome to Envision</div>

          <p className="welcome-message">
            I am delighted to welcome you to the Envision family. You are
            joining a company built on innovation, collaboration, and a shared
            vision of creating solutions that inspire and transform lives. At
            Envision, every team member plays a vital role in shaping our
            future. Your skills, creativity, and dedication will help us
            continue to deliver excellence to our clients and communities
            worldwide.
          </p>
          <p className="welcome-message">
            I encourage you to explore new ideas, embrace challenges, and work
            closely with your colleagues to achieve great things. Together, we
            can turn possibilities into reality and make a meaningful impact.
            Welcome aboard, and I look forward to seeing the amazing
            contributions you will make.
          </p>
        </div>

        {/* Right: Image & Details */}
        <div className="welcome-right">
          <div className="welcome-image-wrapper">
            <img src="/image/Ceo.jpg" alt="CEO" className="welcome-image" />
          </div>
          <div className="welcome-name">C Chandra Sekhar Reddy</div>
          <div className="welcome-designation">CEO &amp; Founder, Envision</div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeMessage;